module.exports = __webpack_public_path__ + "static/media/Sep_2025_3.c9f6b802.webp";